export const ATTACHMENT_URL = '/api/user/v1/attachment'
